export const required = (value) => (value ? undefined : "Required");
export const email = (value) =>
  value && !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(value)
    ? "Invalid email address"
    : undefined;
export const phone = (value) =>
  value && !/^1?\d{10}$/.test(value)
    ? "Invalid phone number, enter a 10-digit US phone number"
    : undefined;



// WEBPACK FOOTER //
// ./src/common/validators.js